import React, { createContext, useContext, useState, useEffect } from "react";

type ApprovalContextType = {
	isApproved: boolean;
	setIsApproved: (v: boolean) => void;
};

const ApprovalContext = createContext<ApprovalContextType | null>(null);

export const ApprovalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [isApproved, setIsApproved] = useState<boolean>(() => {
		return sessionStorage.getItem("isApproved") === "true";
	});

	// keep sessionStorage in sync
	useEffect(() => {
		sessionStorage.setItem("isApproved", String(isApproved));
	}, [isApproved]);

	return <ApprovalContext.Provider value={{ isApproved, setIsApproved }}>{children}</ApprovalContext.Provider>;
};

export const useApproval = () => {
	const ctx = useContext(ApprovalContext);
	if (!ctx) throw new Error("useApproval must be used within ApprovalProvider");
	return ctx;
};
